module.exports = __webpack_public_path__ + "static/img/designBanner3.571d5bd.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designBanner3.gif
// module id = j6bk
// module chunks = 2